import { SegmentedRow } from '../primitives/SegmentedRow'

export type HalfDayValue = 'full' | 'am' | 'pm'

export interface HalfDayRowProps {
  label: string
  date: string
  value: HalfDayValue
  onChange: (next: HalfDayValue) => void
}

const HALF_DAY_OPTIONS = [
  { value: 'full' as const, label: 'FULL' },
  { value: 'am' as const, label: 'AM' },
  { value: 'pm' as const, label: 'PM' },
] as const

/**
 * START / END half-day picker row used inside Step 2 of `ApplyLeavePage`.
 * Mirrors `new_reference/surface-employee.jsx::HalfDayRow` — shows the
 * endpoint label + date and a `FULL / AM / PM` segmented toggle.
 */
export function HalfDayRow({
  label,
  date,
  value,
  onChange,
}: HalfDayRowProps): JSX.Element {
  return (
    <SegmentedRow
      data-testid="half-day-row"
      label={label}
      detail={date}
      options={HALF_DAY_OPTIONS}
      value={value}
      onChange={onChange}
    />
  )
}
